var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMayaPh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17062_333026",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17062_333026)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0013,
    cy: 14.9998,
    r: 9.58333,
    fill: "#202122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3877 11.25C16.5716 11.25 15.7413 11.5832 15.2116 12.1112L15.5122 12.6945L15.3852 12.793C14.8236 11.8536 13.7912 11.25 12.6922 11.25C10.9748 11.25 9.58618 12.7082 9.58618 14.4164V18.0967C9.5847 18.1281 9.58997 18.1595 9.60166 18.1888C9.61335 18.218 9.6312 18.2447 9.65408 18.2669C9.67696 18.2892 9.70436 18.3065 9.73455 18.3179C9.76473 18.3293 9.79703 18.3345 9.82939 18.3331H11.075C11.1354 18.3331 11.1933 18.3098 11.236 18.2684C11.2787 18.227 11.3027 18.1708 11.3027 18.1122V14.3886C11.3027 13.5415 11.8324 12.8473 12.7341 12.8473C13.5785 12.8473 14.1796 13.458 14.1796 14.3607V17.4162C14.1775 17.4465 14.1818 17.4768 14.1923 17.5054C14.2028 17.534 14.2193 17.5601 14.2406 17.5823C14.262 17.6044 14.2878 17.622 14.3165 17.6341C14.3452 17.6461 14.3761 17.6523 14.4074 17.6522H15.5979C15.6291 17.6523 15.66 17.6461 15.6887 17.6341C15.7174 17.622 15.7432 17.6044 15.7646 17.5823C15.786 17.5601 15.8024 17.534 15.8129 17.5054C15.8234 17.4768 15.8277 17.4465 15.8256 17.4162V14.3607C15.8256 13.458 16.4554 12.8473 17.2998 12.8473C18.2015 12.8473 18.7025 13.5415 18.7025 14.3886V18.1108C18.7054 18.1712 18.7324 18.228 18.7778 18.2693C18.8232 18.3106 18.8835 18.333 18.9457 18.3318H20.1754C20.2078 18.3332 20.2401 18.3281 20.2703 18.3167C20.3006 18.3054 20.328 18.288 20.351 18.2658C20.3739 18.2435 20.3918 18.2169 20.4035 18.1875C20.4152 18.1582 20.4205 18.1268 20.419 18.0954V14.4164C20.419 12.7082 19.0878 11.25 17.3845 11.25",
    fill: "#2FF19E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMayaPh);
export default __webpack_public_path__ + "static/media/logoMayaPH.379ada7ac24bb0a7d12f52f1322eaa82.svg";
export { ForwardRef as ReactComponent };